import { render, staticRenderFns } from "./window-create-customer.vue?vue&type=template&id=2e16523f&scoped=true"
import script from "./window-create-customer.vue?vue&type=script&lang=js"
export * from "./window-create-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e16523f",
  null
  
)

export default component.exports